import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { SIMPLE, CAN_INPUT } from 'utils/constants'
import { isCanInput } from 'utils/types/features'
import { getFeatureModuleName } from 'selectors/feature/featureMetadata'
import { makeConditionSelector } from 'selectors/feature/conditions'
import { switchInputType, updateSelectedInput } from 'actions/feature/inputs'
import {
  getIsSixteenBitCanOutput,
  getOutputsByOutputQuery,
  getSingleConditionMetaData,
} from 'selectors/feature/outputs'
import { getShowHarnesses } from 'selectors/feature/harnesses'
import {
  getConfiguredInputs,
  getDefaultInputConfigurations,
} from 'selectors/feature/inputs'
import InputSelectionEditor from './InputSelectionEditor'

const makeMapStateToProps = () => {
  const conditionSelector = makeConditionSelector()

  return (state, ownProps) => {
    const { parentQueryUri, uri, fnId } = ownProps
    const condition = conditionSelector(state, { queryUri: uri })
    const { inputUri } = condition
    const isSingleCondition = !parentQueryUri
    const isSixteenBitCanOutput = getIsSixteenBitCanOutput(state, {
      id: fnId,
    })
    const featureModuleName = getFeatureModuleName(state)
    const showHarnesses = getShowHarnesses(state)
    const configuredInputs = getConfiguredInputs(state)
    const defaultInputConfigurations = getDefaultInputConfigurations(state)
    const [output] =
      getOutputsByOutputQuery(state)
        .get(parentQueryUri || uri)
        ?.toJS() || []
    const { disabled } =
      output && isSingleCondition
        ? getSingleConditionMetaData(state, { id: output?.id, fnId })
        : {}
    return {
      ...condition,
      inputUri,
      isSixteenBitCanOutput,
      isSingleCondition,
      featureModuleName,
      showHarnesses,
      configuredInputs,
      defaultInputConfigurations,
      output,
      disabled,
    }
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      switchInputType,
      updateSelectedInput,
    },
    dispatch
  ),
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const {
    uri,
    configuredInputs,
    defaultInputConfigurations,
    subType,
    defaultNumberOfBits,
  } = stateProps

  const {
    switchInputType: dispatchSwitchInputType,
    updateSelectedInput: dispatchUpdateSelectedInput,
    ...restDispatchProps
  } = dispatchProps

  const switchSingleConditionType = (event) => {
    const newSubType = event.target.value
    const newQueryType = isCanInput(newSubType) ? CAN_INPUT : SIMPLE
    dispatchSwitchInputType(
      uri,
      newSubType,
      { defaultNumberOfBits },
      newQueryType
    )
  }

  // TODO: move to saga so we don't need to pull in input configurations at this level
  const onInputChange = (updatedInputUri) => {
    if (!updatedInputUri) return
    dispatchUpdateSelectedInput(
      uri,
      subType,
      configuredInputs,
      defaultInputConfigurations,
      updatedInputUri
    )
  }

  return {
    ...ownProps,
    ...stateProps,
    ...restDispatchProps,
    switchSingleConditionType,
    onInputChange,
  }
}

const InputSelectionEditorContainer = connect(
  makeMapStateToProps,
  mapDispatchToProps,
  mergeProps
)(InputSelectionEditor)

export default InputSelectionEditorContainer
